define('cq',[],function () {
    return this.CQ;
});
